import React, { useEffect, useState } from 'react'
import {
  CircularProgress,
  Dialog,
  DialogContent,
  Grid,
  Typography,
} from '@material-ui/core'

interface ProgressDialogProps {
  open: boolean
}

export const ProgressDialog = ({ open }: ProgressDialogProps) => {
  const [messagePhase, setMessagePhase] = useState<'early' | 'late'>('early')

  useEffect(() => {
    let timer: NodeJS.Timeout

    if (open) {
      setMessagePhase('early') // start in early phase
      timer = setTimeout(() => {
        setMessagePhase('late') // simulate transition to waiting/downloading
      }, 500) // 500ms matches real "Waiting for response" start
    } else {
      setMessagePhase('early') // reset
    }

    return () => clearTimeout(timer)
  }, [open])

  const getMessage = () => {
    if (messagePhase === 'early') {
      return 'The system’s getting everything ready for you.'
    }
    return 'Submission in process… this may take a few seconds.'
  }

  return (
    <Dialog open={open}>
      <DialogContent style={{ backgroundColor: '#faf2e8' }}>
        <div
          style={{
            fontSize: '16px',
            fontWeight: 600,
            // backgroundColor: 'tomato',
            color: '#fe9802',
          }}
        >
          Please Wait
        </div>
      </DialogContent>
      <DialogContent>
        <Grid container direction="row" alignItems="center">
          <Grid item xs={2}>
            <CircularProgress size={30} style={{ marginRight: 16 }} />
          </Grid>
          <Grid item xs={10}>
            <Typography
              variant="body2"
              style={{ fontSize: '12px', alignSelf: 'end' }}
            >
              {getMessage()}
            </Typography>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  )
}
